<template>
  <vs-row>
    <form>
      <vs-row vs-type="flex">
        <vs-col vs-lg="6" vs-sm="12">
          <vs-input label="Kategória név (kötelező)" v-model="selected.MenuName"></vs-input>
          <vs-input type="number" label="Maximum rendelési idő aznapra (óra)" v-model="selected.MaxOrderHour"></vs-input>
          <vs-select label="Legközelebbi szállítás" v-model="selected.ClosestDelivery">
            <vs-select-item value="today" text="Aznap" selected/>
            <vs-select-item value="next_day" text="Következő nap"/>
          </vs-select>
          <vs-checkbox v-model="pickupOnly">Tárgynap csak elvitelre</vs-checkbox>
          <vs-checkbox v-model="visible">Rendelési oldalon látszik</vs-checkbox>
          <vs-checkbox v-model="withBox">Ételdoboz választható</vs-checkbox>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12">
          <label for="fileUpload_new">
            <input id="fileUpload_new" type="file" style="visibility: hidden;" accept=".jpg,.png" @input="setImage()">
            <img class="itemImage" alt="Menu Image" :src="imgSrc"/>
          </label>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-input label="Információs szöveg" v-model="infoText" class="mt-1"></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="justify-content-center">
        <vs-button @click="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés</vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "new_menu",
  props: ['selected'],
  data() {
    return {
      pickupOnly: false,
      visible: false,
      withBox: false,
      imgSrc: this.$root.imagePath +'/default.jpg',
      infoText: ''
    }
  },
  methods: {
    save() {
      let self = this;
      self.selected.PickupOnly = self.pickupOnly;
      self.selected.Visible = self.visible;
      self.selected.WithBox = self.withBox;
      self.selected.InfoText = self.infoText;

      let input = document.getElementById("fileUpload_new");
      let form = new FormData();

      if (input !== null && input.files !== null && input.files.length !== 0)
        form.append('menuImage', input.files[0]);
      form.append('menuData', JSON.stringify(self.selected));

      axiosInstance({
        method: 'post',
        url: "admin/menuController.php?action=new",
        data: form,
        headers: {'Content-Type': 'multipart/form-data'},
        config: {
          withCredentials: true
        }
      }).then((resp) => {
        self.$vs.notify({
          title: 'Rendszerüzenet',
          position: 'top-right',
          text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
          color: resp.data.status === 'OK' ? 'success' : 'danger',
          icon: resp.data.status === 'OK' ? 'check_box' : 'error'
        });
        self.$parent.$emit('closemodal');
      })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });

    },
    isNotSaveable() {
      return !this.selected.MenuName;
    },
    setImage() {
      let self = this;
      let input = document.getElementById("fileUpload_new");
      if (input.files && input.files[input.files.length - 1]) {
        let reader = new FileReader();
        if (input.files[input.files.length - 1].size / 1024 / 1024 > 5) {
          self.$vs.notify({
            title: 'Rendszerüzenet',
            position: 'top-right',
            text: 'A  fájl mérete túl nagy.',
            color: 'danger',
            icon: 'error'
          });
          input.value = '';
          return;
        }
        reader.readAsDataURL(input.files[input.files.length - 1]);
        reader.onload = function (e) {
          self.imgSrc = e.target.result
        };
      }
    }
  }
}
</script>

<style scoped>
.con-vs-checkbox {
  margin-top: 15px;
}

.vs-input, .con-select {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}

label {
  text-align: center;
}

.itemImage {
  border: 1px solid #ccc;
  width: 270px;
  height: 190px;
  overflow: hidden;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  background-size: cover;
}
</style>